var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"pagePlay"},[_c('video',{ref:"video",staticClass:"a-video full-video",attrs:{"src":"https://hhc.kubsau.ru/upload/iblock/457/kouh4tk1oabibrbn00mwwk8t7hy223qa/КУБГАУ ФИНАЛ_2.mp4","preload":"metadata","controls":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }